import React, { useState, useEffect } from 'react';
import '../App.css'
import MessageForm from '../components/MessageForm';
import { useUploadContext } from "../contexts/UploadContext.js";
import useDragAndDrop from "../hooks/UseDragAndDrop.js";

const TopicChat = ({ selectedProjectData, selectedtopic
  // , topics
}) => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  console.log("selectedProjectData:",selectedProjectData)
  console.log("selectedtopic:",selectedtopic)

  // if (!selectedProjectData) return <div>Loading...</div>;

  useEffect(() => {

  })

  const { uploadAttachments, updateUploadAttachments } = useUploadContext();
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileDrop = (files) => {
    // const newEntries = files.map((file) => ({
    //   fileName: file.name,
    //   file, // 將檔案物件存入
    //   access: "", // 初始為空，submit 時再更新
    //   client: "",
    //   project: "",
    // }));
    // updateUploadData(newEntries); // 將新檔案加入 context
    const newEntries = files.map((file) => ({
      fileName: file.name,
      file, // 儲存檔案物件
      // ...commonData, // 即時同步表單資料
    }));
    updateUploadAttachments(newEntries); // 更新 Context，覆蓋舊檔案
    console.log(uploadAttachments);
  };

  // 自定義 Hook，處理文件拖放邏輯
  const { isDragging, handleDragOver, handleDragLeave, handleDrop } = useDragAndDrop(handleFileDrop);

  return (
    <div
      // className="wrapper"
      className={`wrapper ${isDragging ? "dragging" : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {isDragging &&
        <>
          <div className="dragging-overlay" />
          <div className="dragging-hint">
            <div>Add anything</div>
            <div>Drop any file here to add it to the conversation</div>
          </div>
        </>
      }
      <div className="content-container">
        <div className={`main-content ${isSidebarVisible ? "shifted" : ""}`}
          style={{
            maxWidth: `calc(100% - ${isSidebarVisible ? "370px" : "0px"})`,
          }}
        >
          <div className="content">
            {/* <h2>Case Name: {selectedProjectData.order.case_name}</h2>
            <h3> ▸ {selectedProjectData.project.project_name}</h3>
            <h3>Topic Name: {selectedtopic.title}</h3> */}
            <div># {selectedProjectData.order.case_name}
            ▸{selectedProjectData.project.project_name}
            ▸{selectedtopic.title}</div>
            <MessageForm
              isSidebarVisible={isSidebarVisible}
              setIsSidebarVisible={setIsSidebarVisible}
              selectedProjectData={selectedProjectData}
              selectedtopic={selectedtopic}
            // topics={topics}
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default TopicChat;
